import { SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES } from "../../../constants/constantList";

/**
 * Display labels (UI) ↔ adapter types used in workflow / RTP (matches SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES where applicable).
 */
export const API_SERVICE_TYPE_OPTIONS = [
  { value: "AS2", label: "AS2" },
  { value: "BridgeGateMSMQ", label: "BridgeGateMSMQ" },
  { value: "BridgeGateHTTP", label: "BridgeGateHTTP (RESTful API)" },
  { value: "Kafka", label: "Kafka" },
  { value: "BridgeGateFTP", label: "BridgeGateFTP" },
  { value: "FILE", label: "FILE" },
  { value: "BridgeGateWebService", label: "BridgeGate Web Service" },
  { value: "BridgeGateSocket", label: "BridgeGateSocket" },
  { value: "BridgeGateMQSeries", label: "BridgeGateMQSeries" },
];

const allowed = new Set(SERVICE_SUPPORTED_GETDATA_ADAPTER_TYPES);

/** Options restricted to adapters that support RTP services (GetData service list). */
export const FILTERED_API_SERVICE_TYPE_OPTIONS = API_SERVICE_TYPE_OPTIONS.filter((o) =>
  allowed.has(o.value)
);
